import React, { Component } from "react";
import { ImageItem } from "../../../common/statelessView";
import { fetchData, search } from "../../../../_actions/sidebarSliderActions";
import { connect } from "react-redux";
import { wsCopyFromTemplate } from "../../../../_actions/webSocketAction";
import { closeSlider } from "../../../../_actions/sidebarSliderActions";
import SuperList from "../mediaPanel/SuperList";
import { withTranslation } from "react-i18next";

class TextBlockList extends Component {
  onTxtClick = (data) => {
    this.props.wsCopyFromTemplate(this.props.activePage.id, data);
    if (this.props.isMobileView) {
      this.props.closeSlider();
    }
  };

  render() {
    const { sidebarSlider, t } = this.props;
    const { loaded, payload, hasMore } = sidebarSlider;

    const childElements = payload.map((txtBlock) => {
      const payload = txtBlock.id;
      return (
        <div
          className="item item-textblock"
          onClick={() => this.onTxtClick(txtBlock.id)}
          key={txtBlock.id}
          data-grid-groupkey={txtBlock.groupKey}
        >
          <ImageItem
            data={payload}
            key={txtBlock.id}
            url={txtBlock.image}
            alt={txtBlock.description}
            width={txtBlock.image_width}
            height={txtBlock.image_height}
            nativeImageStyles={{height: (152.5 * parseInt(txtBlock.image_height)) /
            parseInt(txtBlock.image_width)}}
            showOverlayInfo={false}
            isUsedInSwiper={false}
          />
        </div>
      );
    });

    return (
      <>
        <SuperList
          list="text-gallery"
          loaded={loaded}
          searchPlaceholder={t("search.search_text_effects")}
          notFound={t("errors.not_found")}
          errorsView={null}
          hasMore={hasMore}
          loadPage={this.loadPage}
        >
          {childElements}
        </SuperList>
      </>
    );
  }

  loadPage = (groupKey) => {
    // There is no searchText then fetch general images and add into InfiniteGrid
    if (!this.props.searchText) {
      this.props.fetchData(this.props.sidebarSlider.source, {
        ...this.props,
        groupKey,
      });
    } else {
      this.props.search(
        this.props.sidebarSlider.source,
        this.props.searchText,
        { ...this.props, groupKey }
      );
    }
  };
}

const mapStateToProps = (state) => ({
  panelType: state.sidebarSlider.sliderPanelType,
  sidebarSlider: state.sidebarSlider,
  activePage: state.editor.activePage,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({
  fetchData: (source, props) => dispatch(fetchData(source, props)),
  wsCopyFromTemplate: (activePageId, payload) =>
    dispatch(wsCopyFromTemplate(activePageId, payload)),
  closeSlider: () => dispatch(closeSlider()),
  search: (source, searchTerm, props) =>
    dispatch(search(source, searchTerm, props)),
});

export default withTranslation(["common"])(
  connect(mapStateToProps, mapDispatchToProps)(TextBlockList)
);
